import React from 'react';
import GeneralInformation from './generalInformation'
import ContentContainer from '../contentContainer'
import BinaKontrast from './binakontrast'
import { useParams } from 'react-router-dom';



const GlobalContents = () => {
  const { content } = useParams();
  let contentComponent
  if (content.toLowerCase() == "generalinformation"){
    contentComponent=<GeneralInformation />
  }
  if (content.toLowerCase() == "binakontrast"){
    contentComponent=<BinaKontrast />
  }
  return (
    <ContentContainer>
      {contentComponent}
    </ContentContainer>
  );
}

export default GlobalContents;
